import styled from 'styled-components';
import Box from 'ui-box';

// eslint-disable-next-line import/prefer-default-export
export const CustomBox = styled(Box)``;
